<template>
  <v-layout full-height style="height: 100vh">
    <router-view />
    <SnackbarController></SnackbarController>
  </v-layout>
</template>

<script lang="ts" setup>
import SnackbarController from "@/components/SnackbarController.vue";
import { useAppVersion } from "@/composables/useAppVersion";
import { useAuthenticateUser } from "@/composables/useAuthenticateUser";

useAppVersion();
useAuthenticateUser();
</script>
